import axios from "axios";

export default function getAxiosAuthorization(): string|null {
    return axios.defaults.headers.common["Authorization"];
}
